import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-logo" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_UserBadge = _resolveComponent("UserBadge")

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", { src: _ctx.logo }, null, 8, _hoisted_3)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "header-title" }, "International Feedback Management", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_UserBadge)
  ]))
}